import view from './component/coupon/userCoupon.vue'
export default {
  className: '_User',
  render: (residentialQuarters) => {
    return `${residentialQuarters.nickName}-${residentialQuarters.phone}`
  },
  searchKey: ['nickName', 'username'],
  fields: [
    {
      name: 'nickName'
    },
    {
      name: 'phone'
    }
    // {
    //   name: 'room',
    //   render: (record) => {
    //     if (record) {
    //       console.log(record)
    //       if (record.isSelect !== 'passed') {
    //         return '暂未绑定'
    //       } else {
    //         console.log(record.room.community.name + record.room.building.name + record.room.unit.name + record.room.room.name)
    //         return record.room.community.name + record.room.building.name + record.room.unit.name + record.room.room.name
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'identity'
    // }
    // {
    //   name: 'isSelect'
    // }
  ],
  search: [
    'phone'
  ],
  action: {
    create: false,
    edit: false,
    delete: false,
    view: {
      type: 'row',
      text: '查看卡券',
      component: view
    }
  },
  hooks: {
    // beforeInsert ({ data }) {
    //   data.password = '123456'
    // },
    beforeFetch ({ where }) {
      where.isAdmin = {
        $ne: true
      }
      if (!where.phone) {
        where.phone = {
          $exists: true
        }
      }
    }
  }
}
